import React from 'react';
import styled from 'astroturf/react';
import { RelatedPaper } from './types';
import { TextButtonLink } from 'js/design_system/link/TextButtonLink';
import { BodyLink } from 'js/design_system/link/BodyLink';
import { Body } from 'js/design_system/Body';
import { Heading } from 'js/design_system/Heading';
import _RelatedPapersContainer from "RelatedPapers-RelatedPapersContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=RelatedPapersContainer";
import _SectionHeading from "RelatedPapers-SectionHeading.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=SectionHeading";
import _HeadingText from "RelatedPapers-HeadingText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=HeadingText";
import _RelatedPapersGrid from "RelatedPapers-RelatedPapersGrid.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=RelatedPapersGrid";
import _PaperCard from "RelatedPapers-PaperCard.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=PaperCard";
import _PaperContent from "RelatedPapers-PaperContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=PaperContent";
import _PaperTitleText from "RelatedPapers-PaperTitleText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=PaperTitleText";
import _PaperCTAs from "RelatedPapers-PaperCTAs.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=PaperCTAs";
import _PaperThumbnail from "RelatedPapers-PaperThumbnail.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/RelatedPapers.tsx?styleId=PaperThumbnail";


const RelatedPapersContainer = /*#__PURE__*/styled("div", null, {
  displayName: "RelatedPapersContainer",
  styles: _RelatedPapersContainer
});

const SectionHeading = /*#__PURE__*/styled("div", null, {
  displayName: "SectionHeading",
  styles: _SectionHeading
});

// Wrapper for DS Heading with font-weight override to match Figma (500 -> 600)
const HeadingText = /*#__PURE__*/styled("div", null, {
  displayName: "HeadingText",
  styles: _HeadingText
});

const RelatedPapersGrid = /*#__PURE__*/styled("div", null, {
  displayName: "RelatedPapersGrid",
  styles: _RelatedPapersGrid
});

const PaperCard = /*#__PURE__*/styled("div", null, {
  displayName: "PaperCard",
  styles: _PaperCard
});

const PaperContent = /*#__PURE__*/styled("div", null, {
  displayName: "PaperContent",
  styles: _PaperContent
});

const PaperTitleText = /*#__PURE__*/styled("span", null, {
  displayName: "PaperTitleText",
  styles: _PaperTitleText
});

const PaperCTAs = /*#__PURE__*/styled("div", null, {
  displayName: "PaperCTAs",
  styles: _PaperCTAs
});

const PaperThumbnail = /*#__PURE__*/styled("div", null, {
  displayName: "PaperThumbnail",
  styles: _PaperThumbnail
});

export type RelatedPapersProps = {
  papers: RelatedPaper[];
};

export const RelatedPapers: React.FC<RelatedPapersProps> = ({ papers }) => {
  return (
    <RelatedPapersContainer>
      <SectionHeading>
        <HeadingText>
          <Heading size="xs">Related papers</Heading>
        </HeadingText>
      </SectionHeading>
      <RelatedPapersGrid>
        {papers.map((paper, index) => (
          <PaperCard key={index}>
            <PaperContent>
              {/* Title as clickable link */}
              {/* eslint-disable-next-line no-restricted-syntax */}
              <a
                href={paper.url}
                className="paper-card__title-link"
                style={{ textDecoration: 'none', color: 'inherit' }}
                rel={paper.nofollow ? 'nofollow' : undefined}
              >
                <Body size="sm" bold as="p">
                  <PaperTitleText>{paper.title}</PaperTitleText>
                </Body>
              </a>

              {/* Authors with comma separators */}
              {paper.authors && paper.authors.length > 0 && (
                <Body size="xs" as="div">
                  {paper.authors.map((author, idx) => (
                    <React.Fragment key={idx}>
                      <BodyLink
                        size="xs"
                        href={author.url}
                        rel={author.nofollow ? 'nofollow' : undefined}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {author.name}
                      </BodyLink>
                      {idx < paper.authors.length - 1 && <span>, </span>}
                    </React.Fragment>
                  ))}
                </Body>
              )}

              {/* Download CTA */}
              <PaperCTAs>
                {paper.isDownloadable && (
                  <TextButtonLink
                    href={paper.url}
                    icon="download"
                    size="sm"
                    inline={true}
                    onClick={(e) => e.stopPropagation()}
                  >
                    Download free PDF
                  </TextButtonLink>
                )}
              </PaperCTAs>
            </PaperContent>

            {/* Thumbnail */}
            {paper.thumbnailUrl && (
              <PaperThumbnail>
                <img src={paper.thumbnailUrl} alt="" loading="lazy" />
              </PaperThumbnail>
            )}
          </PaperCard>
        ))}
      </RelatedPapersGrid>
    </RelatedPapersContainer>
  );
};
